/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useEffect } from 'react';
import { getSiteSettings } from '../actions/SiteSettingsActions';
import { selectHasSiteSettingsAccess } from '../selectors/scopes';
import { useAppDispatch, useAppSelector } from '../utils/hooks';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const StageSiteSettings = ({
  children
}) => {
  const dispatch = useAppDispatch();
  const hasSiteSettingsAccess = useAppSelector(selectHasSiteSettingsAccess);
  useEffect(() => {
    if (hasSiteSettingsAccess) {
      dispatch(getSiteSettings());
    }
  }, [hasSiteSettingsAccess, dispatch]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export default StageSiteSettings;